import { RouteConfig } from './types';

export const routeConfig: RouteConfig = {
  home: {
    page: 'index'
  },
  'intercom-app': {
    slug: {
      en: 'intercom-app',
      nb: 'intercom-app',
      it: 'intercom-app',
      fr: 'intercom-app',
      de: 'intercom-app',
      pl: 'intercom-app',
      uk: 'intercom-app',
      sv: 'intercom-app',
      es: 'intercom-app',
      fi: 'intercom-app',
      nl: 'intercom-app',
      hu: 'intercom-app',
      'ca-es': 'intercom-app'
    }
  },
  buy: {
    slug: {
      en: 'buy',
      it: 'compra',
      nb: 'kjop',
      fr: 'acheter',
      de: 'kaufen',
      pl: 'kup',
      uk: 'prydbaty',
      sv: 'kopa',
      es: 'compra',
      fi: 'osta',
      nl: 'kopen',
      hu: 'vasarlas',
      'ca-es': 'compra'
    },
    params: '/:productSlug?'
  },
  'buy-gift-card': {
    slug: {
      en: 'buy-gift-card',
      it: 'acquista-una-gift-card',
      nb: 'kjop-gavekort',
      fr: 'acheter-carte-cadeau',
      de: 'kaufen-geschenkkarte',
      pl: 'kup-karte-podarunkowa',
      uk: 'prydbaty-podarunkovu-kartku',
      sv: 'kopa-presentkort',
      es: 'compra-tarjeta-de-regalo',
      fi: 'osta-lahjakortti',
      nl: 'koop-cadeaukaart',
      hu: 'ajandekartya-vasarlas',
      'ca-es': 'compra-targeta-regal'
    },
    params: '/:productSlug?'
  },
  'log-in': {
    slug: {
      en: 'log-in',
      it: 'login',
      nb: 'logg-inn',
      fr: 'connexion',
      de: 'anmelden',
      pl: 'zaloguj-sie',
      uk: 'vhid',
      sv: 'logga-in',
      es: 'iniciar-sesion',
      fi: 'kirjaudu-sisaan',
      nl: 'inloggen',
      hu: 'bejelentkezes',
      'ca-es': 'iniciar-sessio'
    }
  },
  profile: {
    slug: {
      en: 'profile',
      it: 'profilo',
      nb: 'profil',
      fr: 'profil',
      de: 'profil',
      pl: 'profil',
      uk: 'profil',
      sv: 'profil',
      es: 'perfil',
      fi: 'profiili',
      nl: 'profiel',
      hu: 'profil',
      'ca-es': 'perfil'
    },
    params: '/:subSlug?',
    protected: true,
    children: {
      'personal-info': {
        slug: {
          en: 'personal-info',
          it: 'info-personali',
          nb: 'personlig-info',
          fr: 'personnel-info',
          de: 'personliche-info',
          pl: 'informacje-osobiste',
          uk: 'osobysta-informatsiya',
          sv: 'personlig-info',
          es: 'informacion-personal',
          fi: 'henkilokohtaiset-tiedot',
          nl: 'persoonlijke-info',
          hu: 'szemelyes-adatok',
          'ca-es': 'informacio-personal'
        }
      },
      'assign-rfid-card': {
        slug: {
          en: 'assign-rfid-card',
          it: 'assign-rfid-card',
          nb: 'assign-rfid-card',
          fr: 'assign-rfid-card',
          de: 'assign-rfid-card',
          pl: 'assign-rfid-card',
          uk: 'assign-rfid-card',
          sv: 'assign-rfid-card',
          es: 'assign-rfid-card',
          fi: 'assign-rfid-card',
          nl: 'assign-rfid-card',
          hu: 'rfid-kartya-hozzarendelese',
          'ca-es': 'assignar-targeta-rfid'
        }
      },
      trips: {
        slug: {
          en: 'trips',
          it: 'utilizzi',
          nb: 'turer',
          fr: 'trajets',
          de: 'reisen',
          pl: 'podroze',
          uk: 'podorozhi',
          sv: 'resor',
          es: 'viajes',
          fi: 'matkat',
          nl: 'ritten',
          hu: 'utak',
          'ca-es': 'viatges'
        }
      },
      receipts: {
        slug: {
          en: 'receipts',
          it: 'ricevute',
          nb: 'kvitteringer',
          fr: 'recus',
          de: 'quittungen',
          pl: 'paragony',
          uk: 'paragony',
          sv: 'kvitton',
          es: 'recibos',
          fi: 'kuitti',
          nl: 'bonnen',
          hu: 'jegyzetek',
          'ca-es': 'rebuts'
        }
      },
      invoices: {
        slug: {
          en: 'invoices',
          it: 'fatture',
          nb: 'fakturaer',
          fr: 'factures',
          de: 'rechnungen',
          pl: 'faktury',
          uk: 'rakhunki',
          sv: 'fakturor',
          es: 'facturas',
          fi: 'laskut',
          nl: 'facturen',
          hu: 'szamlak',
          'ca-es': 'factures'
        }
      },
      'credit-cards': {
        slug: {
          en: 'credit-cards',
          it: 'carte-di-credito',
          nb: 'kredittkort',
          fr: 'cartes-de-credit',
          de: 'kreditkarten',
          pl: 'karty-kredytowe',
          uk: 'kredytni-karty',
          sv: 'kreditkort',
          es: 'tarjetas-de-credito',
          fi: 'luottokortit',
          nl: 'creditcards',
          hu: 'hitelkartyak',
          'ca-es': 'targetes-de-credit'
        },
        params: '/:paymentId?'
      },
      wallet: {
        slug: {
          en: 'wallet',
          it: 'portafoglio',
          nb: 'lommebok',
          fr: 'portefeuille',
          de: 'brieftasche',
          pl: 'portfel',
          uk: 'gamanets',
          sv: 'planbok',
          es: 'billetera',
          fi: 'lompakko',
          nl: 'portemonnee',
          hu: 'penztarca',
          'ca-es': 'cartera'
        }
      },
      'pin-code': {
        slug: {
          en: 'pin-code',
          it: 'codice-pin',
          nb: 'pinkode',
          fr: 'code-pin',
          de: 'pin-code',
          pl: 'kod-pin',
          uk: 'pin-kod',
          sv: 'pinkod',
          es: 'codigo-pin',
          fi: 'pin-koodi',
          nl: 'pincode',
          hu: 'pin-kod',
          'ca-es': 'codi-pin'
        }
      },
      'your-data': {
        slug: {
          en: 'your-data',
          it: 'tuoi-dati',
          nb: 'dine-data',
          fr: 'vos-donnees',
          de: 'deine-daten',
          pl: 'twoje-dane',
          uk: 'vashi-dani',
          sv: 'dina-data',
          es: 'tus-datos',
          fi: 'tietosi',
          nl: 'uw-gegevens',
          hu: 'adatok',
          'ca-es': 'les-teues-dades'
        }
      }
    }
  },
  receipt: {
    slug: {
      en: 'receipt',
      it: 'ricevuta',
      nb: 'kvittering',
      fr: 'le-recu',
      de: 'quittung',
      pl: 'paragon',
      uk: 'paragon',
      sv: 'kvitto',
      es: 'recibo',
      fi: 'kuitti',
      nl: 'bon',
      hu: 'jegyzet',
      'ca-es': 'rebut'
    },
    params: '/:token'
  },
  invoices: {
    slug: {
      en: 'invoices',
      it: 'fatture',
      nb: 'fakturaer',
      fr: 'factures',
      de: 'rechnungen',
      pl: 'faktury',
      uk: 'rakhunky',
      sv: 'fakturor',
      es: 'facturas',
      fi: 'laskut',
      nl: 'facturen',
      hu: 'szamlak',
      'ca-es': 'factures'
    },
    params: '/:token',
    children: {
      plain: {
        slug: {
          en: 'plain',
          it: 'pianura',
          nb: 'vanlig',
          fr: 'plaine',
          de: 'ebene',
          pl: 'zwykly',
          uk: 'prostyi',
          sv: 'vanlig',
          es: 'liso',
          fi: 'tasainen',
          nl: 'gewoon',
          hu: 'egyszeru',
          'ca-es': 'simple'
        }
      }
    }
  },
  'station-map': {
    slug: {
      en: 'stations',
      it: 'stazioni',
      nb: 'stasjoner',
      fr: 'stations',
      de: 'stationen',
      pl: 'stacje',
      uk: 'stanzii',
      sv: 'stationer',
      es: 'estaciones',
      fi: 'asemat',
      nl: 'stations',
      hu: 'allomasok',
      'ca-es': 'estacions'
    },
    params: '/:view?'
  },
  'redeem-coupon': {
    slug: {
      en: 'redeem-giftcard',
      it: 'riscatta-giftcard',
      nb: 'los-inn-gavekort',
      fr: 'utiliser-carte-cadeau',
      de: 'einlosen-geschenkkarte',
      pl: 'wykorzystaj-karte-podarunkowa',
      uk: 'vykorystay-podarunkovu-kartku',
      sv: 'los-inn-presentkort',
      es: 'canjear-tarjeta-de-regalo',
      fi: 'lunasta-lahjakortti',
      nl: 'wissel-cadeaukaart-in',
      hu: 'ajandekartya-felhasznalas',
      'ca-es': 'bescanviar-targeta-regal'
    }
  },
  'order-confirmation': {
    slug: {
      en: 'order-confirmation',
      it: 'confirmazione-ordine',
      nb: 'ordrebekreftelse',
      fr: 'confirmation-de-commande',
      de: 'bestellbestatigung',
      pl: 'potwierdzenie-zamowienia',
      uk: 'pidtverdzhennya-zamovlennya',
      sv: 'orderbekraftelse',
      es: 'confirmacion-de-pedido',
      fi: 'tilausvahvistus',
      nl: 'orderbevestiging',
      hu: 'rendeles-megerosites',
      'ca-es': 'confirmacio-de-comanda'
    },
    params: '/:token'
  },
  giftcard: {
    slug: {
      en: 'giftcard',
      it: 'giftcard',
      nb: 'gavekort',
      fr: 'carte-cadeau',
      de: 'geschenkkarte',
      pl: 'karta-podarunkowa',
      uk: 'podarunkova-kartka',
      sv: 'presentkort',
      es: 'tarjeta-de-regalo',
      fi: 'lahjakortti',
      nl: 'cadeaukaart',
      hu: 'ajandekartya',
      'ca-es': 'targeta-regal'
    },
    params: '/:token'
  },
  'how-it-works': {
    slug: {
      en: 'how-it-works',
      it: 'come-funziona',
      nb: 'slik-virker-det',
      fr: 'comment-ca-marche',
      de: 'wie-es-funktioniert',
      pl: 'jak-to-dziala',
      uk: 'yak-tse-pratsyuye',
      sv: 'sa-fungerar-det',
      es: 'como-funciona',
      fi: 'kuinka-se-toimii',
      nl: 'hoe-het-werkt',
      hu: 'hogyan-mukodik',
      'ca-es': 'com-funciona'
    }
  },
  'open-data': {
    slug: {
      en: 'open-data',
      it: 'dati-aperti',
      nb: 'apne-data',
      fr: 'open-data',
      de: 'offene-daten',
      pl: 'otwarte-dane',
      uk: 'vidkryti-dani',
      sv: 'oppna-data',
      es: 'datos-abiertos',
      fi: 'avoimet-tiedot',
      nl: 'open-data',
      hu: 'nyitott-adatok',
      'ca-es': 'dades-obertes'
    },
    params: '/:subSlug?',
    children: {
      realtime: {
        slug: {
          en: 'realtime',
          it: 'tempo-reale',
          nb: 'sanntid',
          fr: 'donnees-ouvertes',
          de: 'echtzeit',
          pl: 'dane-otwarte',
          uk: 'realny-chas',
          sv: 'realtid',
          es: 'tiempo-real',
          fi: 'realtieto',
          nl: 'realtime',
          hu: 'realis-ido',
          'ca-es': 'temps-real'
        }
      },
      historical: {
        slug: {
          en: 'historical',
          it: 'storico',
          nb: 'historisk',
          fr: 'historique',
          de: 'historisch',
          pl: 'historyczne',
          uk: 'istorychni',
          sv: 'historisk',
          es: 'historico',
          fi: 'historiallinen',
          nl: 'historisch',
          hu: 'tortenelmi',
          'ca-es': 'historic'
        }
      },
      app: {
        slug: {
          en: 'app-integration',
          it: 'integrazione-app',
          nb: 'app-integrasjon',
          fr: 'app-integration',
          de: 'app-integration',
          pl: 'integracja-aplikacji',
          uk: 'intehratsiya-dodatku',
          sv: 'app-integration',
          es: 'integracion-de-aplicaciones',
          fi: 'sovellusintegraatio',
          nl: 'app-integratie',
          hu: 'app-integracio',
          'ca-es': 'integracio-app'
        }
      }
    }
  },
  'system-status': {
    slug: {
      en: 'system-status',
      it: 'stato-sistema',
      nb: 'system-status',
      fr: 'etat-du-systeme',
      de: 'systemstatus',
      pl: 'status-systemu',
      uk: 'stan-systemy',
      sv: 'systemstatus',
      es: 'estado-del-sistema',
      fi: 'jarjestelman-tila',
      nl: 'systeemstatus',
      hu: 'rendszer-allapot',
      'ca-es': 'estat-del-sistema'
    },
    children: {
      status: {
        slug: {
          en: 'status',
          it: 'stato',
          nb: 'status',
          fr: 'status',
          de: 'status',
          pl: 'status',
          uk: 'stan',
          sv: 'status',
          es: 'estado',
          fi: 'tila',
          nl: 'status',
          hu: 'allapot',
          'ca-es': 'estat'
        },
        params: '/:subSlug/:statusId?'
      }
    }
  },
  app: {
    slug: {
      en: 'app',
      it: 'app',
      nb: 'app',
      fr: 'app',
      de: 'app',
      pl: 'app',
      uk: 'app',
      sv: 'app',
      es: 'app',
      fi: 'app',
      nl: 'app',
      hu: 'app',
      'ca-es': 'app'
    },
    page: 'app-landing'
  },
  onboarding: {
    slug: {
      en: 'onboarding',
      it: 'onboarding',
      nb: 'registrering',
      fr: 'onboarding',
      de: 'registrierung',
      pl: 'rejestracja',
      uk: 'regystratsiya',
      sv: 'registrering',
      es: 'registro',
      fi: 'rekisterointi',
      nl: 'registratie',
      hu: 'regisztracio',
      'ca-es': 'registre'
    }
  },
  business: {
    slug: {
      en: 'business',
      it: 'azienda',
      nb: 'bedrift',
      fr: 'entreprise',
      de: 'unternehmen',
      pl: 'firma',
      uk: 'pidpryyemstvo',
      sv: 'foretag',
      es: 'empresa',
      fi: 'yritys',
      nl: 'zakelijk',
      hu: 'vallalat',
      'ca-es': 'empresa'
    }
  },
  email: {
    slug: {
      en: 'email',
      it: 'email',
      nb: 'email',
      fr: 'email',
      de: 'email',
      pl: 'email',
      uk: 'email',
      sv: 'email',
      es: 'email',
      fi: 'email',
      nl: 'email',
      hu: 'email',
      'ca-es': 'email'
    },
    params: '/:subSlug?',
    children: {
      business_register_welcome: {
        slug: {
          en: 'business_register_welcome',
          it: 'business_register_welcome',
          nb: 'business_register_welcome',
          fr: 'business_register_welcome',
          de: 'business_register_welcome',
          pl: 'business_register_welcome',
          uk: 'business_register_welcome',
          sv: 'business_register_welcome',
          es: 'business_register_welcome',
          fi: 'business_register_welcome',
          nl: 'business_register_welcome',
          hu: 'vallalat-regisztracio-udvozlet',
          'ca-es': 'empresa-registre-benvinguda'
        }
      }
    }
  },
  // 'privacy-policy': {
  //   slug: {
  //     en: 'privacy-policy',
  //     it: 'informativa-sulla-privacy',
  //     nb: 'personvernerklaering',
  //     fr: 'politique-de-confidentialite',
  //     de: 'datenschutzerklarung',
  //     pl: 'polityka-prywatnosci',
  //     uk: 'polityka-konfidencijalnosti',
  //     sv: 'integritetspolicy',
  //     es: 'politica-de-privacidad',
  //     fi: 'tietosuojakaytanto'
  //   }
  // },
  'terms-of-use': {
    slug: {
      en: 'terms-of-use',
      nb: 'vilkaar-for-bruk',
      it: 'termini-e-condizioni',
      fr: 'conditions-dutilisation',
      de: 'nutzungsbedingungen',
      pl: 'warunki-korzystania',
      uk: 'umovy-korystuvannya',
      sv: 'anvandarvillkor',
      es: 'terminos-y-condiciones',
      fi: 'kayttoehdot',
      nl: 'gebruiksvoorwaarden',
      hu: 'hasznalati-feltetelek',
      'ca-es': 'termes-i-condicions'
    }
  },
  'terms-of-purchase': {
    slug: {
      en: 'terms-of-purchase',
      nb: 'vilkaar-for-kjop',
      it: 'termini-di-acquisto',
      fr: 'conditions-dachat',
      de: 'kaufbedingungen',
      pl: 'warunki-zakupu',
      uk: 'umovy-kupivli',
      sv: 'kopsvillkor',
      es: 'terminos-de-compra',
      fi: 'ostoehtoja',
      nl: 'aankoopvoorwaarden',
      hu: 'vasarlasi-feltetelek',
      'ca-es': 'condicions-de-compra'
    }
  },
  'email-confirmation': {
    slug: {
      en: 'email-confirmation',
      it: 'conferma-via-e-mail',
      nb: 'e-postbekreftelse',
      fr: 'confirmation-par-courriel',
      de: 'e-mail-bestatigung',
      pl: 'potwierdzenie-e-mail',
      uk: 'pidtverdzhennya-e-mail',
      sv: 'e-post-bekraftelse',
      es: 'email-de-confirmacion',
      fi: 'sahkopostivahvistus',
      nl: 'e-mailbevestiging',
      hu: 'e-mail-megerosites',
      'ca-es': 'confirmacio-email'
    },
    params: '/:token'
  }
};

export default routeConfig;
